import React, {Component} from 'react';

import SkilItem from './SkilItem';

const jQuery = window.jQuery,
	$ = jQuery;

class SkillSlider extends Component {

	componentWillMount() {
	}

	componentDidMount() {
		this.$node = $(this.refs.slider);
		const self = this;
		self.$node.owlCarousel({
			loop        : true,
			margin      : 60,
			smartSpeed  : 400,
			stagePadding: 50,
			nav         : false,
			dots        : false,
			autoWidth   : true,
			autoHeight  : true,
			responsive  : {
				0   : {
					items: 3,
				},
				400 : {
					items: 4,
				},
				500 : {
					items: 5,
				},
				620 : {
					items: 7,
				},
				700 : {
					items: 8,
				},
				992 : {
					items: 5,
				},
				1200: {
					items: 6,
				}
			}
		})
		// skills animation
			.waypoint({
				handler: function(/*direction*/) {
					$(this.element).find('.singel-hr-inner').each(function() {
						$(this).css('height', $(this).data('height'));
					});
				},
				offset : '60%'
			});
		$('.skl-ctrl').find('.go').on('click', function(e) {
			e.preventDefault();
			if ($(this).hasClass('go-left')) {
				self.$node.trigger('prev.owl.carousel');
				return;
			}
			self.$node.trigger('next.owl.carousel');
		});
	}

	render() {
		const {data, className} = this.props;
		return (
			<div className={className}>
				<div ref="slider" className="clearfix owl-carousel owl-theme skill-graph">
					{data.map((item, index) => <SkilItem key={index} {...item} />)}
				</div>
			</div>
		);
	}
}

export default SkillSlider;



// WEBPACK FOOTER //
// ./src/components/elements/Skill/SkillSlider.js